<template>
  <div class="relative">
    <ul
      class="gap-x-2 gap-y-4"
      :class="[layout, { wrap: layout === 'flex' }]"
      :style="{
        gridTemplateColumns: layout === 'grid'
          ? `repeat(${Math.min(filter.options.length, 3)}, minmax(0, 1fr))`
          : undefined,
      }"
    >
      <li v-for="({ color, id, label }, i) in filter.options" :key="id + i">
        <vf-color-filter v-model="model" :color style="width: 4.625rem" :value="id">
          {{ label }}
        </vf-color-filter>
      </li>
    </ul>
    <div v-if="loading" class="absolute-0 bg-white op-50" />
  </div>
</template>

<script lang="ts" setup>
import type { ColorFilter } from '#types/filters'

const { layout = 'flex' } = defineProps<{
  filter: ColorFilter
  layout?: 'flex' | 'grid'
  loading?: boolean
}>()

const model = defineModel<string[]>()
</script>
